import uhaulStore from "../../CustomRedux/UhaulStore";
import ExceptionLogger from "../../ExceptionHelper";
import GetLiveChatHeader from "../../LiveChatHeaderHelper";
import ApiService from "./ApiService";

export default class FeatureToggleService extends ApiService {
  async isParkFeatureOn(): Promise<boolean> {
    try {
      return (await this.#isParkFeatureOn()) === "True";
    } catch (error) {
      ExceptionLogger(error, "FeatureToggleService.isParkFeatureOn", error);
    }
    return false;
  }

  #isParkFeatureOn = async () => {
    return fetch(
      `${uhaulStore.getState().UhaulReducer.config.liveChatApiUrl
      }ParkFeatureToggle`,
      {
        method: "GET",
        headers: GetLiveChatHeader()
      }
    )
      .then(async (response) => response.text())
      .then(text => {
        return text;
      })
      .catch((err) => {
        console.log("FETCH ERROR: ", err);
        ExceptionLogger(err, "FeatureToggleService", "Error with #isParkFeatureOn", "", "");

      });
  };
}
